export default __webpack_public_path__ + "static/logo-e75aab6050df5fd9418709c038df2435.png";